// extracted by mini-css-extract-plugin
module.exports = {"BtnDestroy":"_1X7pM2Z-fyo-KgQqb3YLGx _3xlZTUXHXdvD8W3hxB92_s"};